import loginMutation from './anon/mutations/login.graphql';
import loginCustomerMutation from './auth/mutations/loginCustomer.graphql';

export { loginCustomerMutation, loginMutation };

export type * from './anon/mutations/login.generated-types';
export type * from './auth/mutations/loginCustomer.generated-types';
